(function simpleBundlesUiEnhancer() {
  if (window.__marcaSimpleBundlesUiEnhancerLoaded) return;
  window.__marcaSimpleBundlesUiEnhancerLoaded = true;

  const APP_CONTAINER_SELECTOR = '[data-simple-bundles-options]';
  const APP_OPTIONS_SELECTOR = '#simple-bundles-io-options';
  const PROCESSED_ATTR = 'data-marca-simple-bundles-processed';
  const SWATCH_STYLE_LISTED_CLASS = 'swatch-style-listed';
  const swatchMappingCache = new Map();

  const dispatchSelectChange = (select, value) => {
    if (select.value !== value) {
      select.value = value;
    }
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const normalizeSwatchValue = (value) => value.replace(/"/g, '').trim().toLowerCase();

  const getValidOptions = (select) => Array.from(select.options).filter((option) => {
    if (option.disabled) return false;
    return option.value !== '';
  });

  const getLinkedLabel = (select, optionsRoot) => {
    if (!select.id) return null;
    return optionsRoot.querySelector(`label[for="${select.id}"]`) || null;
  };

  const hideOriginalField = (select, label) => {
    if (label) {
      label.style.display = 'none';
      label.setAttribute('aria-hidden', 'true');
    }
    select.style.display = 'none';
    select.setAttribute('aria-hidden', 'true');
  };

  const hasSwatchMapping = (value) => {
    const normalizedValue = normalizeSwatchValue(value);
    if (!normalizedValue) return false;
    if (swatchMappingCache.has(normalizedValue)) {
      return swatchMappingCache.get(normalizedValue);
    }

    const probe = document.createElement('span');
    probe.className = 'opt-label opt-label--swatch';
    probe.dataset.swatch = normalizedValue;
    probe.style.position = 'absolute';
    probe.style.left = '-9999px';
    probe.style.pointerEvents = 'none';
    probe.style.visibility = 'hidden';
    document.body.appendChild(probe);

    const styles = window.getComputedStyle(probe);
    const color = styles.getPropertyValue('--swatch-background-color').trim();
    const image = styles.getPropertyValue('--swatch-background-image').trim();
    document.body.removeChild(probe);

    const hasColor = color && color !== 'transparent' && color !== 'rgba(0, 0, 0, 0)' && color !== 'none' && color !== 'initial' && color !== 'inherit';
    const hasImage = image && image !== 'none' && image !== 'initial' && image !== 'inherit';
    const hasMapping = Boolean(hasColor || hasImage);
    swatchMappingCache.set(normalizedValue, hasMapping);
    return hasMapping;
  };

  const createSwatchSelector = (select, label, validOptions, optionsRoot) => {
    const fieldset = document.createElement('fieldset');
    fieldset.className = 'option-selector option-selector--custom';
    fieldset.dataset.selectorType = 'listed';
    fieldset.dataset.option = label ? label.textContent.trim() : select.name;

    const legend = document.createElement('legend');
    legend.className = 'label';
    legend.textContent = label ? label.textContent.trim() : select.name;
    fieldset.appendChild(legend);

    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'option-selector__btns flex flex-wrap';
    fieldset.appendChild(buttonContainer);

    const shouldHideSwatchText = !document.body.classList.contains(SWATCH_STYLE_LISTED_CLASS);
    const selectSafeName = (select.id || select.name || 'simple-bundle-option').replace(/[^a-zA-Z0-9_-]/g, '-');
    const radioName = `marca-simple-bundle-${selectSafeName}`;

    validOptions.forEach((option, index) => {
      const optionValue = option.value;
      const optionLabel = option.textContent.trim() || optionValue;
      const radioId = `${radioName}-opt-${index}`;

      const input = document.createElement('input');
      input.type = 'radio';
      input.className = 'opt-btn visually-hidden focus-label js-option';
      input.id = radioId;
      input.name = radioName;
      input.value = optionValue;
      input.required = select.required;
      if (select.value === optionValue || option.selected || (!select.value && index === 0)) {
        input.checked = true;
      }

      input.addEventListener('change', () => {
        if (!input.checked) return;
        dispatchSelectChange(select, optionValue);
      });

      const swatchLabel = document.createElement('label');
      swatchLabel.className = 'opt-label opt-label--swatch btn relative text-center';
      swatchLabel.setAttribute('for', radioId);
      swatchLabel.dataset.swatch = normalizeSwatchValue(optionValue);

      const text = document.createElement('span');
      text.className = shouldHideSwatchText ? 'visually-hidden js-value' : 'js-value';
      text.textContent = optionLabel;
      swatchLabel.appendChild(text);

      buttonContainer.appendChild(input);
      buttonContainer.appendChild(swatchLabel);
    });

    select.addEventListener('change', () => {
      const currentValue = select.value;
      const radios = buttonContainer.querySelectorAll('input[type="radio"]');
      radios.forEach((radio) => {
        radio.checked = radio.value === currentValue;
      });
    });

    optionsRoot.insertBefore(fieldset, select);
    hideOriginalField(select, label);

    const checkedInput = buttonContainer.querySelector('input[type="radio"]:checked');
    if (checkedInput) {
      dispatchSelectChange(select, checkedInput.value);
    }
  };

  const enhanceOptionsRoot = (optionsRoot) => {
    const selectElements = optionsRoot.querySelectorAll('select[name^="properties["]');
    selectElements.forEach((select) => {
      if (select.hasAttribute(PROCESSED_ATTR)) return;

      const label = getLinkedLabel(select, optionsRoot);
      const validOptions = getValidOptions(select);
      if (!validOptions.length) {
        select.setAttribute(PROCESSED_ATTR, 'empty');
        return;
      }

      if (validOptions.length === 1) {
        dispatchSelectChange(select, validOptions[0].value);
        hideOriginalField(select, label);
        select.setAttribute(PROCESSED_ATTR, 'single');
        return;
      }

      const allOptionsHaveSwatches = validOptions.every((option) => hasSwatchMapping(option.value));
      if (!allOptionsHaveSwatches) {
        select.setAttribute(PROCESSED_ATTR, 'dropdown-fallback');
        return;
      }

      createSwatchSelector(select, label, validOptions, optionsRoot);
      select.setAttribute(PROCESSED_ATTR, 'swatch');
    });
  };

  const scanAndEnhance = (rootNode) => {
    const nodesToScan = [];

    if (rootNode instanceof Element) {
      if (rootNode.matches(APP_OPTIONS_SELECTOR)) nodesToScan.push(rootNode);
      if (rootNode.matches(APP_CONTAINER_SELECTOR)) nodesToScan.push(rootNode);

      rootNode.querySelectorAll(APP_OPTIONS_SELECTOR).forEach((node) => nodesToScan.push(node));
      rootNode.querySelectorAll(APP_CONTAINER_SELECTOR).forEach((node) => nodesToScan.push(node));
    } else {
      document.querySelectorAll(`${APP_CONTAINER_SELECTOR}, ${APP_OPTIONS_SELECTOR}`).forEach((node) => nodesToScan.push(node));
    }

    const visited = new Set();
    nodesToScan.forEach((node) => {
      if (visited.has(node)) return;
      visited.add(node);

      const optionsRoot = node.matches(APP_OPTIONS_SELECTOR) ? node : node.querySelector(APP_OPTIONS_SELECTOR);
      if (optionsRoot) enhanceOptionsRoot(optionsRoot);
    });
  };

  const observeDynamicChanges = () => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((addedNode) => {
          if (addedNode.nodeType !== Node.ELEMENT_NODE) return;
          scanAndEnhance(addedNode);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  const init = () => {
    scanAndEnhance(document);
    observeDynamicChanges();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
